import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Tag } from '@assetaccountant/core/models/tag';
import { TagValue } from '@assetaccountant/core/models/tag-value';
import { OrganisationService } from '@assetaccountant/core/services/organisation.service';
import { TypedFormBuilder } from '@assetaccountant/core/utils/typed-forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-filter-tag-modal',
  templateUrl: './filter-tag-modal.component.html',
  standalone: false,
})
export class FilterTagModalComponent implements OnInit {
  @Input() selectedTags: string[];
  @Input() tags: Tag[];
  @Output() changed = new EventEmitter<string[]>();

  tempSelectedTags: string[];
  activeTag: Tag;
  //tags: Tag[] = [];

  form = this.fb.group({});

  constructor(
    public modal: NgbActiveModal,
    private fb: TypedFormBuilder,
    private organisationService: OrganisationService,
  ) {}

  ngOnInit() {
    forkJoin([this.organisationService.listTags()]).subscribe(([listTagsResponse]) => {
      this.tempSelectedTags = this.selectedTags.map(t => t);
      this.tags = listTagsResponse.tags;
      this.activeTag = this.tags[0];
    });
  }

  onChange(tag: Tag) {
    this.activeTag = tag;
  }

  toggleValue(value: TagValue) {
    const index = this.tempSelectedTags.indexOf(value.id);
    if (index > -1) {
      this.tempSelectedTags.splice(index, 1);
    } else {
      this.tempSelectedTags.push(value.id);
    }
  }

  isSelected(value: TagValue) {
    return this.tempSelectedTags.indexOf(value.id) > -1;
  }

  onSubmit() {
    this.changed.emit(this.tempSelectedTags);
    this.modal.close();
  }
}
